module.exports = __webpack_public_path__ + "assets/img/18_933_big.33674f6b.jpg";